import { FC } from "react";
import { Formik, Form } from 'formik';
import { ButtonSubmit, FormTextArea } from "components";
import { ButtonGroup, Button, ModalBody, ModalFooter } from "@chakra-ui/react";
import { object, SchemaOf, string } from "yup";
import { DraftAsset } from "lib/types";
import { useCreateAsset } from "lib/hooks/useCreateAsset";

type Props = {
  onClose: () => void;
  asset: DraftAsset;
}

enum HtmlFormFields {
  VALUE = 'value',
}

type HtmlSchema = {
  [HtmlFormFields.VALUE]: string;
}

const htmlValidation: SchemaOf<HtmlSchema>  = object().shape({
  [HtmlFormFields.VALUE]: string(),
});

export const DraftHtmlForm: FC<Props> = ({ asset, onClose }) => {
  const { html } = useCreateAsset();

  const onSubmit = async ({ value }): Promise<void> => {
    await html(value);
    onClose();
  }

  return (
    <Formik
      initialValues={{ value: asset?.value || '' }}
      validationSchema={htmlValidation}
      onSubmit={onSubmit}
    >
      <Form>
        <ModalBody>
          <FormTextArea name="value" label="Enter your HTML" autoFocus={true} />
        </ModalBody>
        <ModalFooter>
          <ButtonGroup width="100%" justifyContent="end">
            <Button variant="cancel" onClick={onClose}>Cancel</Button>
            <ButtonSubmit>Save</ButtonSubmit>
          </ButtonGroup>
        </ModalFooter>
      </Form>
    </Formik>
  )
};
